import DateHeadersFull from './components/DateHeadersFull';
import * as React from 'react';
import isDateHeadersOptionDirty from './utils/isDateHeadersOptionDirty';
import saveDateHeadersOption from './actions/saveDateHeadersOption';
import discardDateHeadersOption from './actions/discardDateHeadersOption';
import isDateHeaderEnabled from './utils/isDateHeaderEnabled';
var DateHeadersOption = {
    key: 'dateHeaders',
    titleStringKey: 'optionTitle_dateHeaders',
    searchTermsStringKey: 'optionTitle_dateHeaders',
    fullOptionFormSettings: {
        render: function () { return React.createElement(DateHeadersFull, null); },
        isDirty: isDateHeadersOptionDirty,
        onSave: saveDateHeadersOption,
        onDiscard: discardDateHeadersOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isDateHeaderEnabled,
            onToggle: saveDateHeadersOption,
        },
        order: 6 /* DateHeaders */,
        workloads: 1 /* Mail */,
        customTitle: 'options_dateHeaders_quick_label',
    },
};
export default DateHeadersOption;
//# sourceMappingURL=DateHeadersOption.js.map